module.exports = __webpack_public_path__ + "img/igp-logo.656ea5b6.jpeg";